import { Box, Button } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import washService from "../../../../services/wash.service";
import { IWashRequest } from "../../../../types/wash.types";
import WashHistoryTable from "../../../../components/WashHistoryTable/WashHistoryTable";

const EmployeeWashingHistory = () => {
  const { t } = useTranslation();
  const { ownerID, employeeId } = useParams<{ ownerID: string; employeeId: string }>();
  const navigate = useNavigate();
  const [washes, setWashes] = useState<IWashRequest[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!employeeId) return;
    setLoading(true);
    setError(null);
    washService
      .getEmployeeWashes(employeeId)
      .then((data) => setWashes(data))
      .catch((err: any) => setError(err.message || t("washingHistory.loadFailed")))
      .finally(() => setLoading(false));
    // Re-runs only when employeeId changes; `t` changes identity on
    // language switch, and re-running this fetch because the UI language
    // changed is not wanted.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [employeeId]);

  const respondedBy = washes[0]?.respondedBy;
  const employeeName = respondedBy ? `${respondedBy.firstName} ${respondedBy.lastName}` : "";
  const title = washes.length > 0
    ? t("washingHistory.employeeTitle", { name: employeeName })
    : t("ownerScreens.washingHistory");

  return (
    <Box p={3}>
      <Button
        startIcon={<ArrowBack />}
        onClick={() => navigate(`/dashboard/manage-owners/${ownerID}/employees`)}
        sx={{ textTransform: "none", mb: 2 }}
      >
        {t("employees.title")}
      </Button>
      <WashHistoryTable
        washes={washes}
        loading={loading}
        error={error}
        onDismissError={() => setError(null)}
        title={title}
        emptyMessage={t("washingHistory.emptyForEmployee")}
        showCarWash
        showCustomer
      />
    </Box>
  );
};

export default EmployeeWashingHistory;
